module.exports = __webpack_public_path__ + "img/gm_cards.7ee8cc59.png";